
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crop-image",
      function () {
        return require("private-next-pages/crop-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crop-image"])
      });
    }
  